// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modalComponent_modalWrapper__IhkC3","modal":"modalComponent_modal__+JCcw","popUpWrapper":"modalComponent_popUpWrapper__sIlmH"};